export const environment = {
    production: false,
    apiUrl: "https://analyzerapitst.dataextraction.nl",
    redirectUrl: "http://localhost:4200/",
    "scripts": {
      "build": "ng build --tst"
    }
  };
  